/**
 * Russian for the 09 home pages (§3, §4). Complete for the keys the homes own, so the type
 * makes a missing translation a compile error rather than a silent fallback.
 */
import type { TranslationKey } from "./uz";

export type Home09Key = Extract<TranslationKey, `home09.${string}`>;

export const ru09Home: Record<Home09Key, string> = {
  "home09.unknownClient": "Неизвестный клиент",
  "home09.duration.minutes": "{minutes} мин",
  "home09.duration.hours": "{hours} ч",
  "home09.duration.hoursMinutes": "{hours} ч {minutes} мин",
  "home09.summary.manager.calm": "Нет ожидающих решений и обращений без ответа.",
  "home09.action.remind": "Напомнить",
  "home09.action.open": "Открыть",
  "home09.tip.later": "Позже",
  "home09.tip.year_ago_trip": "{name} год назад в это время путешествовал(а) ({destination}). Время предложить новый сезон.",
  "home09.tip.returned_from_trip": "{name} вернулся(ась) из поездки ({destination}). Спросите впечатления и предложите следующую поездку.",
  "home09.tip.generic": "Пора сделать новое предложение: {name} ({destination}).",
  "home09.tip.noDestination": "направление не указано",
  "home09.near.title": "Близко к продаже",
  "home09.near.empty": "Нет сделок, близких к продаже",
  "home09.filters.branch": "Филиал",
  "home09.filters.period": "Период",
  "home09.filters.week": "Эта неделя",
  "home09.filters.month": "Месяц",
  "home09.delta.points": "п.п.",
  "home09.kpi.label": "Основные показатели",
  "home09.funnel.empty": "За период обращений нет",
  "home09.funnel.insufficient": "Для вывода нужно не меньше {minimum} обращений на этапе.",
  "home09.directions.title": "Выручка по направлениям",
  "home09.directions.empty": "За период выручки нет",
};
